// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import {
  Pagination,
  Button,
  Input,
  Upload,
  Switch,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Dialog,
  Form,
  FormItem,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Message,
  Alert,
  MessageBox,
} from 'element-ui';
import App from './App'
import router from './router'
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Switch)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Alert)
Vue.use(Loading.directive);

import '@/assets/css/element-#A99D53/index.css'
import '@/assets/css/index.scss' // global css
import Aplayer from 'vue-aplayer'
import VueQriously from 'vue-qriously'
import store from './store'
import '@/permission' // permission control
Vue.use(VueQriously)
Vue.config.productionTip = false
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, Aplayer },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js